/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect } from "react";
import { useSubscription } from "@apollo/client";
import STRIPE_WEBHOOK_INFORMATION from "src/graphql/subscriptions/stripe/subscription";
import { useDispatch } from "react-redux";
import { meHandler } from "src/store/reducers/meSlice";

const StripeInformationUpdate = () => {
  const dispatch = useDispatch();

  const { data: stripeWebhookSubscriptionResult } = useSubscription(
    STRIPE_WEBHOOK_INFORMATION,
  );

  useEffect(() => {
    if (stripeWebhookSubscriptionResult?.stripeWebhook) {
      const { stripeWebhook } = stripeWebhookSubscriptionResult;

      const {
        currentCount,
        currentDeletedCount,
        maxCount,
        new_plan,
        new_plan_status,
        plans,
        stripe_subscription_status,
      } = stripeWebhook;

      // updating ME data
      dispatch(
        meHandler({
          currentCount,
          currentDeletedCount,
          maxCount,
          new_plan,
          new_plan_status,
          plans,
          stripe_subscription_status,
        }),
      );
    }
  }, [stripeWebhookSubscriptionResult]);
  return null;
};

export default StripeInformationUpdate;
